import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import HomeSidebar, { HomeTopBar } from './components/HomeSidebar';
import WorkEditorial from './components/WorkEditorial';
import Art from './components/Art';
import About from './components/About';
import CaseStudy from './components/CaseStudy';
import BelongingComingSoon from './components/BelongingComingSoon';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import './styles/reveal.css';

function tabFromPath(pathname) {
  if (pathname === '/about') return 'about';
  if (pathname === '/art') return 'art';
  return 'work';
}

function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = tabFromPath(location.pathname);

  const setActiveTab = (tab) => {
    const paths = { work: '/', about: '/about', art: '/art' };
    navigate(paths[tab] || '/', { preventScrollReset: true });
  };

  return (
    <div className="page-wrapper">
      <HomeTopBar />
      <div className={`home-layout${activeTab === 'about' ? ' home-layout--about' : ''}`}>
        <HomeSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
        <main className="main-content home-content" id="main-content">
          <div key={activeTab} className="tab-content">
            {activeTab === 'work' && <WorkEditorial />}
            {activeTab === 'about' && <About />}
            {activeTab === 'art' && <Art />}
          </div>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<HomePage />} />
        <Route path="/art" element={<HomePage />} />
        <Route path="/case-study/:slug" element={<CaseStudy />} />
        <Route path="/coming-soon/belonging" element={<BelongingComingSoon />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
